import * as wordliftCloud from "wordlift-cloud";

window.wordliftCloud = wordliftCloud;
